import api from './api';

/**
 * Serviço para APIs de relatórios
 */
export const relatoriosApi = {
  // Função buscarEstatisticas antiga removida - usar buscarEstatisticasApi que aceita filtros

  // Buscar dados consolidados de senhas atuais e histórico
  async buscarDadosConsolidados(filtros = {}) {
    try {
      console.log('[DEBUG] buscarDadosConsolidados - Iniciando com filtros:', filtros);
      
      // Buscar dados das senhas atuais
      const senhasAtuaisPromises = [
        api.get('/senhas/aguardando'),
        api.get('/senhas/chamadas'),
        api.get('/senhas/em-atendimento'),
        api.get('/senhas/finalizadas')
      ];

      console.log('[DEBUG] buscarDadosConsolidados - Buscando dados do histórico...');
      // Buscar dados do histórico de senhas
      const historicoPromise = api.get('/senhas/historico');

      // Executar todas as consultas em paralelo
      const allPromises = [...senhasAtuaisPromises, historicoPromise];
      console.log('[DEBUG] buscarDadosConsolidados - Executando', allPromises.length, 'promessas em paralelo');
      const responses = await Promise.allSettled(allPromises);
      
      let todasSenhas = [];
      
      // Consolidar dados das senhas atuais (primeiras 4 responses)
      responses.slice(0, 4).forEach((response, index) => {
        if (response.status === 'fulfilled' && response.value.data.success) {
          const senhas = response.value.data.data || [];
          todasSenhas = todasSenhas.concat(senhas);
          console.log(`[DEBUG] buscarDadosConsolidados - Senhas atuais - Fonte ${index + 1}: ${senhas.length} senhas, status: ${response.status}`);
          if (senhas.length > 0) {
            console.log('[DEBUG] buscarDadosConsolidados - Exemplo de senha atual:', JSON.stringify(senhas[0]));
          }
        } else {
          console.warn(`[DEBUG] buscarDadosConsolidados - Falha na fonte ${index + 1}:`, 
            response.status === 'rejected' ? response.reason : 'Resposta sem sucesso');
        }
      });

      // Consolidar dados do histórico (última response)
      const historicoResponse = responses[4];
      if (historicoResponse.status === 'fulfilled' && historicoResponse.value.data.success) {
        const senhasHistorico = historicoResponse.value.data.data || [];
        console.log(`[DEBUG] buscarDadosConsolidados - Histórico de senhas: ${senhasHistorico.length} senhas`);
        
        // Verificar todos os serviços no histórico
        const servicosHistorico = {};
        senhasHistorico.forEach(senha => {
          if (senha.servico_nome) {
            servicosHistorico[senha.servico_nome] = (servicosHistorico[senha.servico_nome] || 0) + 1;
          }
        });
        console.log('[DEBUG] buscarDadosConsolidados - Serviços encontrados no histórico:', servicosHistorico);
        
        if (senhasHistorico.length > 0) {
          console.log('[DEBUG] buscarDadosConsolidados - Exemplo de senha histórico:', JSON.stringify(senhasHistorico[0]));
        }
        
        todasSenhas = todasSenhas.concat(senhasHistorico);
      } else {
        console.warn('[DEBUG] buscarDadosConsolidados - Falha ao obter dados do histórico:', 
          historicoResponse.status === 'rejected' ? historicoResponse.reason : 'Resposta sem sucesso');
      }

      console.log(`[DEBUG] buscarDadosConsolidados - Total de senhas consolidadas: ${todasSenhas.length}`);
      
      // Verificar todos os serviços nas senhas consolidadas
      const servicosConsolidados = {};
      todasSenhas.forEach(senha => {
        if (senha.servico_nome) {
          servicosConsolidados[senha.servico_nome] = (servicosConsolidados[senha.servico_nome] || 0) + 1;
        }
      });
      console.log('[DEBUG] buscarDadosConsolidados - Serviços encontrados (consolidados):', servicosConsolidados);
      
      return todasSenhas;
      
    } catch (error) {
      console.error('[DEBUG] buscarDadosConsolidados - Erro geral:', error);
      
      // Fallback: tentar buscar apenas senhas atuais
      try {
        console.log('[DEBUG] buscarDadosConsolidados - Tentando fallback para senhas atuais...');
        const senhasPromises = [
          api.get('/senhas/aguardando'),
          api.get('/senhas/chamadas'),
          api.get('/senhas/em-atendimento'),
          api.get('/senhas/finalizadas')
        ];

        const responses = await Promise.allSettled(senhasPromises);
        let senhasAtuais = [];
        
        responses.forEach((response, index) => {
          if (response.status === 'fulfilled' && response.value.data.success) {
            const senhas = response.value.data.data || [];
            senhasAtuais = senhasAtuais.concat(senhas);
            console.log(`[DEBUG] buscarDadosConsolidados - Fallback - Fonte ${index + 1}: ${senhas.length} senhas`);
          } else {
            console.warn(`[DEBUG] buscarDadosConsolidados - Fallback - Falha na fonte ${index + 1}`);
          }
        });

        console.log(`[DEBUG] buscarDadosConsolidados - Fallback - Total: ${senhasAtuais.length} senhas`);
        return senhasAtuais;
        
      } catch (fallbackError) {
        console.error('[DEBUG] buscarDadosConsolidados - Erro no fallback:', fallbackError);
        return [];
      }
    }
  },

  // Buscar dados de movimento por horário
  async buscarMovimentoPorHorario(filtros = {}) {
    try {
      console.log('Buscando movimento por horário com filtros:', filtros);
      
      // Usar a mesma abordagem das estatísticas - buscar dados detalhados diretamente
      const todasSenhas = await this.buscarDadosDetalhados(filtros);
      
      if (todasSenhas.success && todasSenhas.data.length > 0) {
        return this.processarDadosPorHorario(todasSenhas.data, filtros);
      } else {
        console.warn('Nenhuma senha encontrada para o período especificado');
        return {
          success: false,
          message: 'Nenhuma senha encontrada para o período especificado',
          data: null
        };
      }
    } catch (error) {
      console.error('Erro ao buscar movimento por horário:', error);
      return {
        success: false,
        message: 'Erro ao buscar dados de movimento por horário',
        data: null
      };
    }
  },

  // Processar dados de senhas para agrupar por horário
  processarDadosPorHorario(senhas, filtros) {
    console.log('Processando dados por horário...', { 
      totalSenhas: senhas.length,
      filtros 
    });

    const horarios = {};
    
    // Inicializar todos os horários das 7h às 20h com 0
    for (let hora = 7; hora <= 20; hora++) {
      const horaFormatada = hora.toString().padStart(2, '0') + ':00';
      horarios[horaFormatada] = 0;
    }

    // Os dados já vêm filtrados do backend, não precisamos filtrar novamente
    console.log(`Total de senhas para processamento: ${senhas.length}`);

    // Agrupar senhas por horário de emissão
    senhas.forEach(senha => {
      if (senha.emitida_em) {
        const dataEmissao = new Date(senha.emitida_em);
        const hora = dataEmissao.getHours();
        
        // Só contar horários entre 7h e 20h
        if (hora >= 7 && hora <= 20) {
          const horaFormatada = hora.toString().padStart(2, '0') + ':00';
          horarios[horaFormatada]++;
        }
      }
    });

    // Converter para array no formato esperado pelo gráfico
    const dadosFormatados = Object.entries(horarios).map(([hora, quantidade]) => ({
      hora,
      quantidade
    }));

    console.log('Dados formatados por horário:', dadosFormatados);
    
    // Calcular total para verificação
    const totalNoGrafico = dadosFormatados.reduce((sum, item) => sum + item.quantidade, 0);
    console.log(`Total de senhas no gráfico: ${totalNoGrafico} (deve ser igual ao total de senhas: ${senhas.length})`);

    return {
      success: true,
      data: {
        movimentoPorHorario: dadosFormatados
      }
    };
  },

  // Buscar dados detalhados de senhas para relatórios
  async buscarDadosDetalhados(filtros = {}) {
    try {
      console.log('[DEBUG] buscarDadosDetalhados - Iniciando com filtros:', filtros);
      
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }
      if (filtros.servicos && filtros.servicos.length > 0) {
        params.append('servicos', filtros.servicos.join(','));
      }
      if (filtros.status && filtros.status.length > 0) {
        params.append('status', filtros.status.join(','));
      }

      console.log('[DEBUG] buscarDadosDetalhados - Parâmetros da URL:', params.toString());

      // Buscar dados detalhados das senhas atuais
      const senhasResponse = api.get(`/senhas/relatorio-detalhado?${params.toString()}`);
      
      // Buscar dados detalhados do histórico
      const historicoResponse = api.get(`/senhas/historico/relatorio-detalhado?${params.toString()}`);
      
      // Executar consultas em paralelo
      const [senhas, historico] = await Promise.allSettled([senhasResponse, historicoResponse]);
      
      let dadosConsolidados = [];
      
      // Consolidar dados das senhas atuais
      if (senhas.status === 'fulfilled' && senhas.value.data.success) {
        const senhasAtuais = senhas.value.data.data || [];
        console.log('[DEBUG] buscarDadosDetalhados - Senhas atuais encontradas:', senhasAtuais.length);
        if (senhasAtuais.length > 0) {
          console.log('[DEBUG] buscarDadosDetalhados - Exemplo de senha atual:', JSON.stringify(senhasAtuais[0], null, 2));
        }
        dadosConsolidados = dadosConsolidados.concat(senhasAtuais);
      } else {
        console.warn('[DEBUG] buscarDadosDetalhados - Erro ao buscar senhas atuais:', 
          senhas.status === 'rejected' ? senhas.reason : senhas.value?.data?.message);
      }
      
      // Consolidar dados do histórico
      if (historico.status === 'fulfilled' && historico.value.data.success) {
        const senhasHistorico = historico.value.data.data || [];
        console.log('[DEBUG] buscarDadosDetalhadas - Senhas do histórico encontradas:', senhasHistorico.length);
        if (senhasHistorico.length > 0) {
          console.log('[DEBUG] buscarDadosDetalhados - Exemplo de senha do histórico:', JSON.stringify(senhasHistorico[0], null, 2));
        }
        dadosConsolidados = dadosConsolidados.concat(senhasHistorico);
      } else {
        console.warn('[DEBUG] buscarDadosDetalhados - Erro ao buscar histórico:', 
          historico.status === 'rejected' ? historico.reason : historico.value?.data?.message);
      }
      
      console.log('[DEBUG] buscarDadosDetalhados - Total de senhas consolidadas:', dadosConsolidados.length);
      
      // Verificar se há duplicatas (senhas que podem estar tanto na tabela atual quanto no histórico)
      const senhasUnicas = [];
      const idsProcessados = new Set();
      
      dadosConsolidados.forEach(senha => {
        const id = senha.id || `${senha.numero}_${senha.emitida_em}`;
        if (!idsProcessados.has(id)) {
          idsProcessados.add(id);
          senhasUnicas.push(senha);
        }
      });
      
      console.log('[DEBUG] buscarDadosDetalhados - Senhas únicas após remoção de duplicatas:', senhasUnicas.length);
      
      return {
        success: true,
        data: senhasUnicas
      };
      
    } catch (error) {
      console.error('[DEBUG] buscarDadosDetalhados - Erro geral:', error);
      throw error;
    }
  },

  // Buscar dados detalhados de usuários para relatórios
  async buscarDadosUsuariosDetalhados(filtros = {}) {
    try {
      console.log('[DEBUG] buscarDadosUsuariosDetalhados - Iniciando com filtros:', filtros);
      
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }

      const response = await api.get(`/senhas/relatorio-usuarios-detalhado?${params.toString()}`);
      
      if (response.data.success) {
        console.log('[DEBUG] buscarDadosUsuariosDetalhados - Dados recebidos:', response.data.data);
        return {
          success: true,
          data: response.data.data || []
        };
      } else {
        console.error('[DEBUG] buscarDadosUsuariosDetalhados - Erro na resposta:', response.data.message);
        return {
          success: false,
          message: response.data.message || 'Erro ao buscar dados detalhados dos usuários',
          data: []
        };
      }
      
    } catch (error) {
      console.error('[DEBUG] buscarDadosUsuariosDetalhados - Erro:', error);
      return {
        success: false,
        message: 'Erro ao conectar com o servidor',
        data: []
      };
    }
  },

  // Buscar dados agregados por período (para gráficos temporais)
  async buscarDadosPorPeriodo(filtros = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }
      if (filtros.agrupamento) {
        params.append('agrupamento', filtros.agrupamento); // 'hora', 'dia', 'semana', 'mes'
      }

      // Buscar dados por período das senhas atuais
      const senhasResponse = api.get(`/senhas/relatorio-periodo?${params.toString()}`);
      
      // Buscar dados por período do histórico
      const historicoResponse = api.get(`/senhas/historico/relatorio-periodo?${params.toString()}`);
      
      // Executar consultas em paralelo
      const [senhas, historico] = await Promise.allSettled([senhasResponse, historicoResponse]);
      
      let dadosConsolidados = [];
      
      // Consolidar dados das senhas atuais
      if (senhas.status === 'fulfilled' && senhas.value.data.success) {
        dadosConsolidados = dadosConsolidados.concat(senhas.value.data.data || []);
      }
      
      // Consolidar dados do histórico
      if (historico.status === 'fulfilled' && historico.value.data.success) {
        dadosConsolidados = dadosConsolidados.concat(historico.value.data.data || []);
      }
      
      return {
        success: true,
        data: dadosConsolidados
      };
      
    } catch (error) {
      console.error('Erro ao buscar dados por período:', error);
      throw error;
    }
  },

  // Buscar dados dos serviços executados
  async buscarDadosServicosExecutados(filtros = {}) {
    try {
      console.log('[DEBUG] buscarDadosServicosExecutados - Iniciando com filtros:', filtros);
      
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }
      
      console.log('[DEBUG] buscarDadosServicosExecutados - Parâmetros da URL:', params.toString());
      
      // Chamar o endpoint do backend
      const response = await api.get(`/senhas/relatorio-servicos-executados?${params.toString()}`);
      
      if (response.data.success) {
        console.log('[DEBUG] buscarDadosServicosExecutados - Dados obtidos:', response.data.data);
        return {
          success: true,
          data: response.data.data
        };
      } else {
        console.error('[DEBUG] buscarDadosServicosExecutados - Erro na resposta:', response.data.message);
        throw new Error(`Erro ao buscar dados dos serviços executados: ${response.data.message}`);
      }
    } catch (error) {
      console.error('[DEBUG] buscarDadosServicosExecutados - Erro:', error);
      throw error;
    }
  },

  // Buscar dados por serviço
  async buscarDadosPorServico(filtros = {}) {
    try {
      console.log('[DEBUG] buscarDadosPorServico - Iniciando com filtros:', filtros);
      
      // Buscar dados detalhados (senhas atuais + histórico) com filtros aplicados no backend
      console.log('[DEBUG] buscarDadosPorServico - Chamando buscarDadosDetalhados...');
      const response = await this.buscarDadosDetalhados(filtros);
      
      if (!response.success) {
        console.warn('[DEBUG] buscarDadosPorServico - Erro ao buscar dados detalhados:', response.message);
        return {
          success: false,
          message: response.message || 'Erro ao buscar dados detalhados',
          data: null
        };
      }
      
      const todasSenhas = response.data || [];
      
      console.log(`[DEBUG] buscarDadosPorServico - Recebidas ${todasSenhas.length} senhas no total`);
      if (todasSenhas.length > 0) {
        console.log('[DEBUG] buscarDadosPorServico - Estrutura de uma senha:', 
          Object.keys(todasSenhas[0]).join(', '));
      } else {
        console.warn('[DEBUG] buscarDadosPorServico - Nenhuma senha recebida para processamento!');
        return {
          success: false,
          message: 'Nenhuma senha encontrada para o período especificado',
          data: null
        };
      }

      // Os dados já vêm filtrados do backend, não precisamos filtrar novamente
      const senhasFiltradas = todasSenhas;
      
      console.log(`[DEBUG] buscarDadosPorServico - Senhas já filtradas pelo backend: ${senhasFiltradas.length} senhas`);
      
      // Verificar se temos dados
      if (senhasFiltradas.length === 0) {
        console.warn('[DEBUG] buscarDadosPorServico - Nenhuma senha retornada pelo backend');
        return {
          success: false,
          message: 'Nenhuma senha encontrada para o período especificado',
          data: null
        };
      }
      
      // Agrupar por serviço com cálculos detalhados
      console.log('[DEBUG] buscarDadosPorServico - Agrupando por serviço com cálculos detalhados...');
      const servicosData = {};
      
      // Primeiro passo: agrupar senhas por serviço
      senhasFiltradas.forEach(senha => {
        console.log(`[DEBUG] Processando senha: ID=${senha.id}, serviço=${senha.servico_nome}, data=${senha.emitida_em}`);
        if (senha.servico_nome) {
          if (!servicosData[senha.servico_nome]) {
            servicosData[senha.servico_nome] = {
              senhas: [],
              totalQuantidade: 0
            };
          }
          servicosData[senha.servico_nome].senhas.push(senha);
          servicosData[senha.servico_nome].totalQuantidade++;
        } else {
          console.warn('[DEBUG] buscarDadosPorServico - Senha sem nome de serviço:', senha.id || 'sem id');
        }
      });
      
      console.log('[DEBUG] buscarDadosPorServico - Serviços encontrados:', Object.keys(servicosData));
      
      // Verificar se temos dados de serviços
      if (Object.keys(servicosData).length === 0) {
        console.warn('[DEBUG] buscarDadosPorServico - Nenhum serviço encontrado nos dados');
        return {
          success: false,
          message: 'Nenhum serviço encontrado nos dados disponíveis',
          data: null
        };
      }
      
      // Calcular total geral para percentuais
      const totalGeral = senhasFiltradas.length;
      
      // Segundo passo: calcular métricas para cada serviço
      const servicosCalculados = Object.entries(servicosData).map(([nomeServico, dadosServico]) => {
        const senhasDoServico = dadosServico.senhas;
        const quantidade = dadosServico.totalQuantidade;
        
        // Calcular percentual
        const percentual = totalGeral > 0 ? (quantidade / totalGeral) * 100 : 0;
        
        // Calcular tempo médio de atendimento (apenas senhas finalizadas)
        const senhasFinalizadas = senhasDoServico.filter(senha => 
          senha.status === 'FINALIZADA' && 
          senha.chamada_em && 
          senha.finalizada_em
        );
        
        let tempoMedioAtendimento = 0;
        if (senhasFinalizadas.length > 0) {
          const totalAtendimentoMs = senhasFinalizadas.reduce((total, senha) => {
            const chamadaEm = new Date(senha.chamada_em);
            const finalizadaEm = new Date(senha.finalizada_em);
            return total + (finalizadaEm.getTime() - chamadaEm.getTime());
          }, 0);
          tempoMedioAtendimento = totalAtendimentoMs / (senhasFinalizadas.length * 1000 * 60); // em minutos
        }
        
        // Calcular tempo médio de espera (senhas que foram chamadas)
        const senhasChamadas = senhasDoServico.filter(senha => 
          senha.chamada_em && 
          senha.emitida_em
        );
        
        let tempoMedioEspera = 0;
        if (senhasChamadas.length > 0) {
          const totalEsperaMs = senhasChamadas.reduce((total, senha) => {
            const emitidaEm = new Date(senha.emitida_em);
            const chamadaEm = new Date(senha.chamada_em);
            return total + (chamadaEm.getTime() - emitidaEm.getTime());
          }, 0);
          tempoMedioEspera = totalEsperaMs / (senhasChamadas.length * 1000 * 60); // em minutos
        }
        
        console.log(`[DEBUG] Métricas calculadas para ${nomeServico}:`, {
          quantidade,
          percentual: percentual.toFixed(2),
          tempoMedioAtendimento: tempoMedioAtendimento.toFixed(2),
          tempoMedioEspera: tempoMedioEspera.toFixed(2),
          senhasFinalizadas: senhasFinalizadas.length,
          senhasChamadas: senhasChamadas.length
        });
        
        return {
          servico: nomeServico,
          quantidade,
          percentual: Math.round(percentual * 100) / 100, // 2 casas decimais
          tempoMedioAtendimento: Math.round(tempoMedioAtendimento * 100) / 100, // em minutos
          tempoMedioEspera: Math.round(tempoMedioEspera * 100) / 100 // em minutos
        };
      });
      
      console.log('[DEBUG] buscarDadosPorServico - Serviços com métricas calculadas:', servicosCalculados);
      
      return {
        success: true,
        data: servicosCalculados
      };
      
    } catch (error) {
      console.error('[DEBUG] buscarDadosPorServico - Erro geral:', error);
      
      return {
        success: false,
        message: 'Erro ao processar dados dos serviços',
        data: null
      };
    }
  },

  // Buscar dados de tempo de espera e atendimento
  async buscarDadosTempoEspera(filtros = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }

      // Buscar dados de tempos das senhas atuais
      const senhasResponse = api.get(`/senhas/relatorio-tempos?${params.toString()}`);
      
      // Buscar dados de tempos do histórico
      const historicoResponse = api.get(`/senhas/historico/relatorio-tempos?${params.toString()}`);
      
      // Executar consultas em paralelo
      const [senhas, historico] = await Promise.allSettled([senhasResponse, historicoResponse]);
      
      let dadosConsolidados = [];
      
      // Consolidar dados das senhas atuais
      if (senhas.status === 'fulfilled' && senhas.value.data.success) {
        dadosConsolidados = dadosConsolidados.concat(senhas.value.data.data || []);
      }
      
      // Consolidar dados do histórico
      if (historico.status === 'fulfilled' && historico.value.data.success) {
        dadosConsolidados = dadosConsolidados.concat(historico.value.data.data || []);
      }
      
      return {
        success: true,
        data: dadosConsolidados
      };
      
    } catch (error) {
      console.error('Erro ao buscar dados de tempo:', error);
      throw error;
    }
  },

  // Buscar lista de serviços disponíveis
  async buscarServicos() {
    try {
      const response = await api.get('/servicos');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar serviços:', error);
      throw error;
    }
  },

  // Buscar lista de usuários/atendentes disponíveis
  async buscarUsuarios() {
    try {
      const response = await api.get('/usuarios');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
      return { success: false, data: [] };
    }
  },

  // Buscar serviços ordenados por tempo médio de atendimento
  async buscarServicosPorTempo(filtros = {}) {
    try {
      console.log('[DEBUG] buscarServicosPorTempo - Iniciando com filtros:', filtros);
      
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }
      
      // Chamar o endpoint do backend
      const response = await api.get(`/senhas/servicos-por-tempo?${params.toString()}`);
      
      if (response.data.success) {
        console.log('[DEBUG] buscarServicosPorTempo - Dados obtidos:', response.data.data);
        return {
          success: true,
          data: response.data.data
        };
      } else {
        console.error('[DEBUG] buscarServicosPorTempo - Erro na resposta:', response.data.message);
        return {
          success: false,
          message: response.data.message || 'Erro ao buscar dados dos serviços por tempo',
          data: null
        };
      }
    } catch (error) {
      console.error('[DEBUG] buscarServicosPorTempo - Erro ao buscar:', error);
      return {
        success: false,
        message: 'Erro ao buscar dados dos serviços por tempo',
        data: null
      };
    }
  },
  


  // Buscar dados de atendentes
  async buscarDadosAtendentes(filtros = {}) {
    try {
      console.log('[DEBUG] buscarDadosAtendentes - Iniciando com filtros:', filtros);
      
      // Construir parâmetros de consulta
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }
      
      // Chamar o endpoint real de dados de atendentes
      const response = await api.get(`/senhas/relatorio-atendentes?${params.toString()}`);
      
      // Verificar se a resposta foi bem-sucedida
      if (response.data.success) {
        console.log('[DEBUG] buscarDadosAtendentes - Dados reais recebidos:', response.data.data);
        return {
          success: true,
          data: response.data.data
        };
      } else {
        console.error('[DEBUG] buscarDadosAtendentes - Resposta sem sucesso:', response.data.message);
        
        return {
          success: false,
          message: response.data.message || 'Erro ao buscar dados dos atendentes',
          data: null
        };
      }
      
    } catch (error) {
      console.error('[DEBUG] buscarDadosAtendentes - Erro:', error);
      
              return {
          success: false,
          message: 'Erro ao buscar dados dos atendentes',
          data: null
        };
    }
  },
  


  // Buscar estatísticas diretamente da API
  async buscarEstatisticasApi(filtros = {}) {
    try {
      console.log('[DEBUG] buscarEstatisticasApi - Iniciando com filtros:', filtros);
      
      // Construir parâmetros de consulta
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }
      
      // Chamar o endpoint de estatísticas
      const response = await api.get(`/senhas/estatisticas?${params.toString()}`);
      
      if (response.data.success) {
        console.log('[DEBUG] buscarEstatisticasApi - Estatísticas recebidas:', response.data.data);
        return {
          success: true,
          data: response.data.data
        };
      } else {
        console.error('[DEBUG] buscarEstatisticasApi - Erro na resposta:', response.data.message);
        throw new Error(`Erro ao buscar estatísticas: ${response.data.message}`);
      }
    } catch (error) {
      console.error('[DEBUG] buscarEstatisticasApi - Erro:', error);
      throw error;
    }
  },

    // Buscar informações sobre o dia mais movimentado (nova implementação usando endpoint específico)
  async buscarDatasMovimentadas(filtros = {}) {
    try {
      console.log('[DEBUG] buscarDatasMovimentadas - Iniciando com filtros:', filtros);
      
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }
      
      console.log('[DEBUG] buscarDatasMovimentadas - Parâmetros da URL:', params.toString());
      
      // Chamar o novo endpoint específico do backend
      const response = await api.get(`/senhas/dia-mais-movimentado?${params.toString()}`);
      
      if (response.data.success) {
        const diaMaisMovimentado = response.data.data;
        console.log('[DEBUG] buscarDatasMovimentadas - Dia mais movimentado recebido:', diaMaisMovimentado);
        
        // Retornar no formato esperado pelo componente (array com o dia mais movimentado)
        return {
          success: true,
          data: {
            diasMaisMovimentados: diaMaisMovimentado ? [diaMaisMovimentado] : []
          }
        };
      } else {
        console.warn('[DEBUG] buscarDatasMovimentadas - Erro na resposta:', response.data.message);
        return {
          success: false,
          message: response.data.message || 'Erro ao buscar dados das datas movimentadas',
          data: null
        };
      }
      
    } catch (error) {
      console.error('[DEBUG] buscarDatasMovimentadas - Erro:', error);
      return {
        success: false,
        message: 'Erro ao conectar com o servidor para buscar datas movimentadas',
        data: null
      };
    }
  },
  


  // Buscar senhas atendidas por um usuário específico
  async buscarSenhasAtendidasPorUsuario(usuarioId, filtros = {}) {
    try {
      console.log('[DEBUG] buscarSenhasAtendidasPorUsuario - Iniciando com filtros:', { usuarioId, filtros });
      
      const params = new URLSearchParams();
      
      if (filtros.dataInicio) {
        params.append('dataInicio', filtros.dataInicio);
      }
      if (filtros.dataFim) {
        params.append('dataFim', filtros.dataFim);
      }

      const response = await api.get(`/senhas/usuario/${usuarioId}/senhas-atendidas?${params.toString()}`);
      
      if (response.data.success) {
        console.log('[DEBUG] buscarSenhasAtendidasPorUsuario - Dados recebidos:', response.data.data);
        return {
          success: true,
          data: response.data.data
        };
      } else {
        console.error('[DEBUG] buscarSenhasAtendidasPorUsuario - Erro na resposta:', response.data.message);
        return {
          success: false,
          message: response.data.message || 'Erro ao buscar senhas atendidas pelo usuário',
          data: { usuario: null, senhas: [] }
        };
      }
      
    } catch (error) {
      console.error('[DEBUG] buscarSenhasAtendidasPorUsuario - Erro:', error);
      return {
        success: false,
        message: 'Erro ao conectar com o servidor',
        data: { usuario: null, senhas: [] }
      };
    }
  },

  // Buscar relatório detalhado de todos os usuários
  async buscarRelatorioUsuariosDetalhado(filtros = {}) {
    try {
      console.log('[DEBUG] buscarRelatorioUsuariosDetalhado - Iniciando com filtros:', filtros);
      
      const params = new URLSearchParams();
      if (filtros.dataInicio) params.append('dataInicio', filtros.dataInicio);
      if (filtros.dataFim) params.append('dataFim', filtros.dataFim);
      
      const url = `/senhas/relatorio-usuarios-detalhado${params.toString() ? '?' + params.toString() : ''}`;
      console.log('[DEBUG] buscarRelatorioUsuariosDetalhado - URL:', url);
      
      const response = await api.get(url);
      console.log('[DEBUG] buscarRelatorioUsuariosDetalhado - Resposta:', response.data);
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data
        };
      } else {
        console.error('[DEBUG] buscarRelatorioUsuariosDetalhado - Erro na resposta:', response.data.message);
        return {
          success: false,
          message: response.data.message || 'Erro ao buscar relatório de usuários',
          data: []
        };
      }
    } catch (error) {
      console.error('[DEBUG] buscarRelatorioUsuariosDetalhado - Erro:', error);
      return {
        success: false,
        message: 'Erro ao conectar com o servidor',
        data: []
      };
    }
  },
};

// Buscar detalhes completos de uma senha específica
export const buscarDetalhesSenha = async (senhaId) => {
  try {
    const response = await api.get(`/senhas/detalhes/${senhaId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar detalhes da senha:', error);
    throw error;
  }
};

// Buscar motivos de emissão disponíveis
export const buscarMotivosEmissao = async () => {
  try {
    const response = await api.get('/motivos-emissao');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar motivos de emissão:', error);
    throw error;
  }
};

export default relatoriosApi; 